import { Component, Input } from '@angular/core';
import {
  WagtailImageRichtextInterface,
  WagtailPageContentElementInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-shop-imgrte',
    templateUrl: './shop-imgrte.component.html',
    styleUrls: ['./shop-imgrte.component.scss'],
    standalone: false
})
export class ShopImageRichtextComponent {

  @Input() definition?: WagtailPageContentElementInterface<WagtailImageRichtextInterface>
  content?: WagtailImageRichtextInterface

  ngOnInit(): void {
    if (this.definition) {
      this.content = this.definition.value
    }
  }
}
